import axios from './config'

export default {
    all: function() {
        return axios.get('/computers')
    },

    store: function(computer) {
        return axios.post('/computers', computer)
    },

    show: function(computerID) {
        return axios.get(`/computers/${computerID}`)
    },

    update: function(computer) {
        return axios.put(`/computers/${computer.id}`, computer)
    },

    delete: function(computerID) {
        return axios.delete(`/computers/${computerID}`)
    }
}